import { useTheme } from '@emotion/react';

import type { IconComponent } from '@twistopayments/design-system/icons/constants';

import * as styles from './icon-circle.styles';

export type IconCircleColors =
  | 'primary'
  | 'secondary'
  | 'additional'
  | 'success'
  | 'error'
  | 'warning'
  | 'gray'
  | 'actionPrimary'
  | 'disabled';

export type IconCircleSizes = '24' | '32' | '40' | '48' | '64' | '80';
type IconSizes = '16' | '20' | '24' | '32' | '40' | '48';

type Props = {
  color?: IconCircleColors;
  icon: IconComponent;
  size?: IconCircleSizes;
  className?: string;
  titleAccess?: string;
};

const iconSizeMap: Record<IconCircleSizes, IconSizes> = {
  '24': '16',
  '32': '20',
  '40': '24',
  '48': '32',
  '64': '40',
  '80': '48',
};

const getIconColor = (color: IconCircleColors) => {
  switch (color) {
    case 'actionPrimary':
    case 'primary':
      return 'white';
    default:
      return color;
  }
};

export const IconCircle = ({
  icon,
  color = 'gray',
  size = '40',
  className,
  titleAccess,
}: Props) => {
  const theme = useTheme();

  const Icon = icon;
  const iconSize = iconSizeMap[size];
  const iconColor = getIconColor(color);

  return (
    <div className={className} css={styles.root(theme, color, size)} data-testid="icon-circle">
      <Icon color={iconColor} size={iconSize} titleAccess={titleAccess} />
    </div>
  );
};
